<template>
    <div class="event-screen">
        <vue-custom-scrollbar ref="customScrollbar" id="event-details" class="event-details bang" v-if="club">
            <div class="header">
                <i class="back" @click="closeClub"></i>
                <i class="dots" v-if="club.membership !== 'host' && profile.id" v-show="!reportMenuVisible" v-on:click="showReportMenu"></i>
            </div>

            <ClubDetails :clubId="clubId"/>

            <div class="mobileSidebarHolder positionRight forDesktop"
                v-show="showReportMenu"
                :class="{'active': reportMenuVisible}">
                <div class="mobileSidebarHide" @click="hideReportMenu"></div>
                <div class="mobileSidebar">

                    <div class="report-menu">
                        <div class="inner">
                            <div class="title">{{ trans('clubs.report.title') }}</div>
                            <div class="box">
                                <div class="checkbox-container">
                                    <label class="checkbox-label">
                                        <input type="checkbox" name="wrong_category" value="wrong_category" v-model="reportData">
                                        <span class="checkbox-custom"></span>
                                        <div class="input-title">{{ trans('clubs.report.wrong_type') }}</div>
                                    </label>
                                </div>
                                <div class="checkbox-container">
                                    <label class="checkbox-label">
                                        <input type="checkbox" name="under_age" value="under_age" v-model="reportData">
                                        <span class="checkbox-custom"></span>
                                        <div class="input-title">{{ trans('report_under_age') }}</div>
                                    </label>
                                </div>
                                <div class="checkbox-container">
                                    <label class="checkbox-label">
                                        <input type="checkbox" name="illegal" value="illegal" v-model="reportData">
                                        <span class="checkbox-custom"></span>
                                        <div class="input-title">{{ trans('clubs.report.illegal') }}</div>
                                    </label>
                                </div>
                                <div class="checkbox-container">
                                    <label class="checkbox-label">
                                        <input type="checkbox" name="spam" value="spam" v-model="reportData">
                                        <span class="checkbox-custom"></span>
                                        <div class="input-title">{{ trans('report_spam') }}</div>
                                    </label>
                                </div>
                            </div>
                            <button type="submit" class="btn" @click="sendClubReport">{{ trans('send') }}</button>
                        </div>
                    </div><!--report-menu-->

                </div>
            </div>
        </vue-custom-scrollbar>
    </div>
</template>

<script>
    import {mapActions, mapGetters, mapState} from 'vuex';

    import ClubDetails from "@clubs/views/widgets/club/Item.vue";
    import clubsModule from '@clubs/module/store/type';
    import chatModule from '@chat/module/store/type';

    // custom scrollbar
    import vueCustomScrollbar from 'vue-custom-scrollbar'
    import "vue-custom-scrollbar/dist/vueScrollbar.css"

    export default {
        mixins: [
            require('@general/lib/mixin').default,
            require('@general/lib/mixin-clubs').default,
        ],
        props: ['clubId'],
        data() {
            return {
                menuVisible: false,
                reportMenuVisible: false,
                reportData: []
            }
        },
        components: {
            ClubDetails,
            vueCustomScrollbar
        },
        computed: {
            ...mapState({
                blockedUsersIds: state => state.blockedUsersIds,
                profile: 'profile'
            }),
            club() {
                return this.$store.getters.getClub(this.clubId)
            },
            ...mapGetters({
                unreadClubMessagesCount: chatModule.getters.messages.count.unreadClub
            }),
            heartFilledIn() {
                return this.club.isLiked
            }
        },
        watch: {
            blockedUsersIds: function(blockedUsersIds) {
                if (blockedUsersIds.includes(this.club?.user_id)) {
                    this.closeClub()
                }
            }
        },
        methods: {
            ...mapActions({
                setClub: clubsModule.actions.setClub,
                reportClub: clubsModule.actions.clubs.report,
                toggleClubLike: clubsModule.actions.clubs.like
            }),
            showReportMenu() {
                this.reportMenuVisible = true;
            },
            hideReportMenu() {
                this.reportMenuVisible = false;
            },
            closeFilter() {
                this.hideReportMenu();
            },
            sendClubReport() {
              this.reportClub({
                reason: this.reportData,
                id: this.clubId,
                callback: this.clubReportResponse,
              })
            },
            clubReportResponse(response) {
                if (response.data.success) {
                    this.showSuccessNotification(response.data.trans)
                } else {
                    this.showErrorNotification(response.data.trans)
                }
                this.closeFilter()
            },
        },
        mounted() {
            console.log('[Club Mobile Item] mounted')
            //this.$store.dispatch(clubsModule.actions.clubs.loadInfo, {clubId:this.clubId,edit:0})
            this.$refs.customScrollbar.$forceUpdate()
        },
        activated() {
            console.log('[Club Desktop Item] Activated')
            this.$store.dispatch(clubsModule.actions.membership.remove, this.clubId)
            this.$store.commit('updateUser', { has_club_notifications: false })
        }
    }
</script>
